module.exports = __webpack_public_path__ + "assets/img/hot-goods-top.d1745242.png";